import Layout from "../../../components/layout/layout.js";
import KeyPlayerContactsProfileCleanup from "../../../components/componentsPage/keyPlayerContactsProfileCleanup/index.js";

function KeyPlayerContactsProfileCleanupPage({ component, ...rest }) {
  return <Layout Component={KeyPlayerContactsProfileCleanup} controlsDisabled={true} {...rest} />;
}

export default KeyPlayerContactsProfileCleanupPage;
